import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';
//import 'react-datepicker/dist/react-datepicker.css';

class CustomInput extends React.PureComponent {
  render() {
    const { placeholder, onClick, className, invalid, ...rest } = this.props;
    return (
      <div
        className={`input-group cursor-pointer ${invalid && 'invalid'
          } ${className}`}
        onClick={onClick}
      >
        <input
          type="text"
          className="form-control"
          {...rest}
          placeholder={placeholder}
        />
        <div className="input-group-append input-group-text text-light">
          <i className="fa fa-calendar fa-fw" />
        </div>
      </div>
    );
  }
}

const AmiDatePicker = (props) => {
  if (props.showTimeSelect === true) {
    return (
      <DatePicker
        showTimeSelect
        {...props}
        dateFormat="MM/DD/YYYY h:mm a"
        customInput={<CustomInput invalid={props.required && !props.selected} />}
      />
    )
  }

  return (
    <DatePicker
      {...props}
      customInput={<CustomInput invalid={props.required && !props.selected} />}
    />
  )
}

class AmiDateRangePicker extends React.PureComponent {
  static propTypes = {
    startDate: PropTypes.instanceOf(moment),
    endDate: PropTypes.instanceOf(moment),
    onStartDateChange: PropTypes.func.isRequired,
    onEndDateChange: PropTypes.func.isRequired,
    labelStartClassName: PropTypes.string,
    labelStart: PropTypes.string,
    labelEndClassName: PropTypes.string,
    labelEnd: PropTypes.string,
  };

  render() {
    const {
      startDate,
      endDate,
      onStartDateChange,
      onEndDateChange,
      labelStartClassName,
      labelStart,
      labelEndClassName,
      labelEnd
    } = this.props;
    return (
      <div className="row">
        <div className="col-12 col-md-6">
          {labelStart &&
            <div className={`"position-relative form-group`}>
              <label className={labelStartClassName || ''}>{labelStart}</label><AmiDatePicker
                startDate={startDate}
                endDate={endDate}
                selected={startDate}
                selectsStart
                onChange={onStartDateChange}
                placeholderText="Start Date"
              /></div>}
          {!labelStart && <AmiDatePicker
            startDate={startDate}
            endDate={endDate}
            selected={startDate}
            selectsStart
            onChange={onStartDateChange}
            placeholderText="Start Date"
          />}
        </div>
        <div className="col-12 col-md-6">
          {labelEnd && <div className={`"position-relative form-group`}>
            <label className={labelEndClassName || ''}>{labelEnd}</label>
            <AmiDatePicker
              startDate={startDate}
              endDate={endDate}
              selected={endDate}
              selectsEnd
              onChange={(endDate) => {
                const correctEndDate = endDate ? endDate.endOf('day') : null;
                onEndDateChange(correctEndDate);
              }}
              placeholderText="End Date"
            />
          </div>}
          {!labelEnd && <AmiDatePicker
            startDate={startDate}
            endDate={endDate}
            selected={endDate}
            selectsEnd
            onChange={(endDate) => {
              const correctEndDate = endDate ? endDate.endOf('day') : null;
              onEndDateChange(correctEndDate);
            }}
            placeholderText="End Date"
          />}
        </div>
      </div>
    );
  }
}

export { AmiDatePicker, AmiDateRangePicker };
